import(/* webpackMode: "eager" */ "/vercel/path0/src/components/restaurants/RestaurantsComponent.tsx")